import React, { useEffect } from 'react';

type StepImageModalProps = {
  open: boolean;
  onClose: () => void;
  src: string;
  alt: string;
  title?: string;
};

const StepImageModal: React.FC<StepImageModalProps> = ({ open, onClose, src, alt, title }) => {
  useEffect(() => {
    if (!open) return;
    const handleKey = (event: KeyboardEvent) => {
      if (event.key === 'Escape') onClose();
    };
    window.addEventListener('keydown', handleKey);
    return () => window.removeEventListener('keydown', handleKey);
  }, [onClose, open]);

  if (!src || !open) return null;

  return (
    <>
      <div
        className="fixed inset-0 z-50 flex items-center justify-center bg-black/70 p-4"
        role="dialog"
        aria-modal="true"
        aria-label={title || alt}
      >
        <button
          type="button"
          className="absolute right-4 top-4 rounded-full bg-white/95 px-3 py-1 text-sm font-semibold text-slate-900 shadow"
          onClick={onClose}
        >
          Close
        </button>
        <div className="max-h-[90vh] max-w-5xl overflow-hidden rounded-2xl bg-white p-4 shadow-2xl">
          <img
            src={src}
            alt={alt}
            className="h-full max-h-[80vh] w-auto max-w-full object-contain"
          />
        </div>
      </div>
    </>
  );
};

export default StepImageModal;
